export default class ShopifyApiError extends Error {
  constructor(message) {
    super(message);
    this.name = 'ShopifyApiError';
  }
}
